import { render, staticRenderFns } from "./EditCandidateButton.vue?vue&type=template&id=638477f0&"
import script from "./EditCandidateButton.vue?vue&type=script&lang=js&"
export * from "./EditCandidateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports